import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class ConstraintsApi extends ModelWithFacilityApi {
	constructor(token, clientID, onUnauthorized) {
		super(token, clientID, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "constraints_templates/";
	}

}
